var img = "data:image/svg+xml,%3csvg viewBox='0 0 36 36' width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3e %3crect fill='currentColor' transform='rotate(90 18 18)' x='17' y='10' width='2' height='16' rx='1' fillRule='evenodd' /%3e%3c/svg%3e";

export default img;
//# sourceMappingURL=minus.svg.js.map
